
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const oAuthService = inject(OAuthService);

  if (!oAuthService.hasValidAccessToken()) {
    router.navigate(['acceso']);
  }
  return true;
};
